import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2", // Couleur principale
      contrastText: "#ffffff", // Couleur de texte
    },
    secondary: {
      main: "#ff9800", // Couleur secondaire
      contrastText: "#000000",
    },
    error: {
      main: "#d32f2f", // Couleur pour les messages d'erreur
    },
    warning: {
      main: "#ffa726", // Couleur d'avertissement
    },
    info: {
      main: "#0288d1", // Couleur des messages d'information
    },
    success: {
      main: "#2e7d32", // Couleur de succès
    },
    background: {
      default: "#f4f4f4", // Arrière-plan global
      paper: "#ffffff", // Arrière-plan des composants "papier"
    },
    text: {
      primary: "#333333", // Couleur principale du texte
      secondary: "#757575", // Couleur secondaire
    },
  },
});

export default theme;
